module.exports = __webpack_public_path__ + "static/apple-icon-120x120-1122b48aef8e3b7d594d02c770092d67.png";